import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { BroadcastTopics } from 'services/wsService';

import type { ISocketData as INewMessageSocketData } from 'infrastructure/hooks/smsDashboard/useNewMessageBroadcast';
import type { RootState } from 'store';

interface IProps {
  conversationStateChange?: (data: any) => void;
  conversationAssignStateChange?: (data: any) => void;
  doctorMessageStatusChange?: (data: any) => void;
  newMessage?: (data: INewMessageSocketData) => void;
}

export const useSmsDashboardSocket = (props: IProps) => {
  const {
    conversationStateChange,
    conversationAssignStateChange,
    doctorMessageStatusChange,
    newMessage,
  } = props;
  const socket = useSelector((state: RootState) => state.socket);

  useEffect(() => {
    if (!socket.isConnected || !socket.client) return;

    if (conversationStateChange) {
      socket.client.on(
        BroadcastTopics.ConversationStateChange,
        conversationStateChange,
      );
    }

    if (conversationAssignStateChange) {
      socket.client.on(
        BroadcastTopics.ConversationAssignStateChange,
        conversationAssignStateChange,
      );
    }

    if (doctorMessageStatusChange) {
      socket.client.on(
        BroadcastTopics.DoctorMessageStatusChange,
        doctorMessageStatusChange,
      );
    }

    if (newMessage) {
      socket.client.on(BroadcastTopics.NewMessage, newMessage);
    }

    return () => {
      socket.client?.off(
        BroadcastTopics.ConversationStateChange,
        conversationStateChange,
      );
      socket.client?.off(
        BroadcastTopics.ConversationAssignStateChange,
        conversationAssignStateChange,
      );
      socket.client?.off(
        BroadcastTopics.DoctorMessageStatusChange,
        doctorMessageStatusChange,
      );
      socket.client?.off(BroadcastTopics.NewMessage, newMessage);
    };
  }, [
    socket.isConnected,
    conversationStateChange,
    conversationAssignStateChange,
    doctorMessageStatusChange,
    newMessage,
  ]);
};
